import React from 'react';
import { Modal } from 'antd';
import {
    ExclamationCircleOutlined,
    CheckCircleOutlined,
    StopOutlined,
    DollarOutlined,
    ReloadOutlined,
    CloseCircleOutlined,
} from '@ant-design/icons';

const actionConfigMap = {
    approve: {
        title: 'Duyệt hoa hồng?',
        okText: 'Xác nhận duyệt',
        cancelText: 'Đóng',
        icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
        okButtonProps: {},
        sections: (count) => [
            {
                type: 'text',
                content: <>Bạn đang duyệt <b>{count}</b> bản ghi hoa hồng.</>,
            },
            {
                type: 'list',
                title: 'Sau khi duyệt:',
                items: [
                    'Các bản ghi sẽ chuyển sang trạng thái "đã duyệt".',
                    'Đây sẽ là căn cứ để thực hiện bước chi trả hoa hồng tiếp theo.',
                ],
            },
            {
                type: 'warning',
                title: 'Lưu ý:',
                items: [
                    'Chỉ nên duyệt khi đã kiểm tra xong số liệu hoa hồng.',
                ],
            },
        ],
    },

    unapprove: {
        title: 'Hủy duyệt hoa hồng?',
        okText: 'Xác nhận hủy duyệt',
        cancelText: 'Đóng',
        icon: <CloseCircleOutlined style={{ color: '#fa8c16' }} />,
        okButtonProps: {
            danger: true,
        },
        sections: (count) => [
            {
                type: 'text',
                content: <>Bạn đang hủy duyệt <b>{count}</b> bản ghi hoa hồng.</>,
            },
            {
                type: 'list',
                title: 'Sau khi hủy duyệt:',
                items: [
                    'Các bản ghi sẽ quay về trạng thái "chưa duyệt".',
                    'Các bản ghi này sẽ không thể tiếp tục chi trả cho đến khi được duyệt lại.',
                ],
            },
            {
                type: 'danger',
                title: 'Lưu ý:',
                items: [
                    'Các bản ghi đã chi không được phép hủy duyệt.',
                ],
            },
        ],
    },

    paid: {
        title: 'Xác nhận đã chi hoa hồng?',
        okText: 'Xác nhận đã chi',
        cancelText: 'Đóng',
        icon: <DollarOutlined style={{ color: '#1677ff' }} />,
        okButtonProps: {
            type: 'primary',
        },
        sections: (count) => [
            {
                type: 'text',
                content: <>Bạn đang đánh dấu <b>{count}</b> bản ghi hoa hồng là đã chi.</>,
            },
            {
                type: 'list',
                title: 'Sau khi xác nhận:',
                items: [
                    'Các bản ghi sẽ chuyển sang trạng thái "đã chi".',
                    'Số liệu sẽ được ghi nhận vào phần đã thanh toán.',
                ],
            },
            {
                type: 'warning',
                title: 'Lưu ý:',
                items: [
                    'Nên chỉ xác nhận sau khi việc chi trả thực tế đã hoàn tất.',
                ],
            },
        ],
    },

    invalidate: {
        title: 'Vô hiệu các dòng chưa chi?',
        okText: 'Xác nhận vô hiệu',
        cancelText: 'Đóng',
        icon: <StopOutlined style={{ color: '#ff4d4f' }} />,
        okButtonProps: {
            danger: true,
        },
        sections: (count) => [
            {
                type: 'text',
                content: <>Bạn đang yêu cầu vô hiệu <b>{count}</b> bản ghi hoa hồng.</>,
            },
            {
                type: 'list',
                title: 'Hệ thống sẽ xử lý:',
                items: [
                    'Chỉ vô hiệu các bản ghi chưa thanh toán.',
                    'Các bản ghi đã thanh toán sẽ được giữ nguyên.',
                ],
            },
            {
                type: 'danger',
                title: 'Lưu ý:',
                items: [
                    'Dữ liệu vô hiệu sẽ không còn được tính vào số liệu hiệu lực.',
                    'Cần kiểm tra kỹ trước khi thực hiện thao tác này.',
                ],
            },
        ],
    },

    rebuild: {
        title: 'Tính lại hoa hồng?',
        okText: 'Xác nhận tính lại',
        cancelText: 'Đóng',
        icon: <ReloadOutlined style={{ color: '#722ed1' }} />,
        okButtonProps: {},
        sections: () => [
            {
                type: 'text',
                content: <>Hệ thống sẽ kiểm tra lại dịch vụ đã chọn và ghi nhận phần hoa hồng còn thiếu.</>,
            },
            {
                type: 'list',
                title: 'Sau khi tính lại:',
                items: [
                    'Các khoản đang chờ duyệt được thay thế idempotent theo cùng nguồn dịch vụ.',
                    'Aggregate phụ thuộc trực tiếp vào dịch vụ sẽ được đồng bộ lại.',
                ],
            },
            {
                type: 'warning',
                title: 'Lưu ý:',
                items: [
                    'Chỉ nên tính lại khi dữ liệu nguồn của dịch vụ đã được cập nhật chính xác.',
                    'Dịch vụ có kỳ đã khóa, khoản đã duyệt hoặc đã đưa vào chi trả sẽ bị chặn.',
                ],
            },
        ],
    },
    rebuild_summary: {
        title: 'Tính lại số liệu tổng hợp?',
        okText: 'Xác nhận tính lại',
        cancelText: 'Đóng',
        icon: <ReloadOutlined style={{ color: '#722ed1' }} />,
        okButtonProps: {},
        sections: () => [
            {
                type: 'text',
                content: <>Hệ thống sẽ tính lại toàn bộ số liệu thống kê hoa hồng theo bộ lọc hiện tại.</>,
            },
            {
                type: 'list',
                title: 'Sau khi tính lại:',
                items: [
                    'Các chỉ số như doanh thu, hoa hồng, giữ lại sẽ được cập nhật lại theo dữ liệu mới nhất.',
                    'Số liệu tổng hợp sẽ được đồng bộ với các khoản hoa hồng đang có hiệu lực.',
                ],
            },
            {
                type: 'warning',
                title: 'Lưu ý:',
                items: [
                    'Chỉ nên thực hiện khi nghi ngờ số liệu đang bị lệch.',
                    'Thao tác này không thay đổi dữ liệu gốc, chỉ cập nhật thống kê.',
                ],
            },
        ],
    },
};

const sectionStyleMap = {
    text: {
        background: '#fafafa',
        border: '1px solid #f0f0f0',
        color: '#262626',
    },
    list: {
        background: '#f6ffed',
        border: '1px solid #b7eb8f',
        color: '#262626',
    },
    warning: {
        background: '#fffbe6',
        border: '1px solid #ffe58f',
        color: '#ad6800',
    },
    danger: {
        background: '#fff2f0',
        border: '1px solid #ffccc7',
        color: '#cf1322',
    },
};

const SectionBlock = ({ section }) => {
    const style = sectionStyleMap[section.type] || sectionStyleMap.text;

    return (
        <div
            style={{
                ...style,
                borderRadius: 10,
                padding: '12px 14px',
                marginTop: 10,
                lineHeight: 1.65,
            }}
        >
            {section.content && <div>{section.content}</div>}

            {section.title && (
                <div style={{ fontWeight: 600, marginBottom: section.items?.length ? 6 : 0 }}>
                    {section.title}
                </div>
            )}

            {!!section.items?.length && (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {section.items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export const openCommissionActionModal = ({
    action,
    count = 0,
    loading = false,
    onOk,
}) => {
    const config = actionConfigMap[action];
    if (!config) return;

    Modal.confirm({
        title: config.title,
        icon: config.icon || <ExclamationCircleOutlined />,
        width: 560,
        okText: config.okText,
        cancelText: config.cancelText || 'Đóng',
        okButtonProps: {
            loading,
            ...config.okButtonProps,
        },
        content: (
            <div style={{ marginTop: 8 }}>
                {config.sections(count).map((section, index) => (
                    <SectionBlock key={index} section={section} />
                ))}
            </div>
        ),
        onOk,
    });
};

export const openCommissionRecalculationResult = (result = {}) => {
    const summary = result.recalculation || {};
    const changed = summary.changed_items || [];
    const removed = summary.removed_items || [];
    const unchanged = summary.unchanged_items || [];
    const aggregateRuns = summary.aggregate_runs || [];
    const money = value => value === null || value === undefined
        ? '—'
        : `${Number(value).toLocaleString('vi-VN')} đ`;
    const renderItems = (items, title, type) => items.length ? (
        <SectionBlock
            section={{
                type,
                title,
                items: items.map(item => `${item.employee_name || 'Nhân sự'} · ${item.role_key || '—'} · ${item.component_key || '—'}: ${money(item.before_amount)} → ${money(item.after_amount)}`),
            }}
        />
    ) : null;

    Modal.info({
        title: 'Kết quả tính lại hoa hồng',
        width: 640,
        maskClosable: false,
        content: (
            <div style={{ marginTop: 8 }}>
                <SectionBlock section={{ type: 'text', content: summary.message || 'Đã hoàn tất tính lại hoa hồng cho dịch vụ.' }} />
                {renderItems(changed, 'Khoản đã thay đổi', 'list')}
                {renderItems(removed, 'Khoản không còn phát sinh', 'warning')}
                {unchanged.length ? <SectionBlock section={{ type: 'text', title: 'Khoản giữ nguyên', items: [`${unchanged.length} khoản không thay đổi số tiền.`] }} /> : null}
                {aggregateRuns.length ? <SectionBlock section={{ type: 'list', title: 'Tổng hợp liên quan', items: [`Đã đồng bộ ${aggregateRuns.length} bản tổng hợp phụ thuộc.`] }} /> : null}
            </div>
        ),
    });
};
